export interface IWarehouseAddressDto {
    name: string;
    streetName: string;
    streetNumber: string;
    city: string;
    country: string;
    additionalAddress: string;
}

export class WarehouseAddress {
    private readonly _name: string;
    private readonly _streetName: string;
    private readonly _streetNumber: string;
    private readonly _city: string;
    private readonly _country: string;
    private readonly _additionalAddress: string;

    public constructor(dto: IWarehouseAddressDto) {
        this._name = dto.name;
        this._streetName = dto.streetName;
        this._streetNumber = dto.streetNumber;
        this._city = dto.city;
        this._country = dto.country;
        this._additionalAddress = dto.additionalAddress;
    }

    get name(): string {
        return this._name;
    }

    get fullAddress() {
        if (!(this._streetName == null || this._streetName.trim() === "")) {
            return `${this._country}, ${this._city}, ${this._streetName} ${this._streetNumber ?? ""}`;
        }

        return `${this._country}, ${this._city}, ${this._additionalAddress}`;
    }
}
